import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { compose } from 'redux';
import BasicText from '../../../shared/components/formComponents/groups/BasicText';
import BasicTextArea from '../../../shared/components/formComponents/groups/BasicTextArea';
import FormFeedback from '../../../shared/components/formComponents/FormFeedback';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../shared/components/VerbButton';

class BehaviorForm extends PureComponent {
    static propTypes = {
        handleSubmit: PropTypes.func,
        onSubmit: PropTypes.func,
        submitting: PropTypes.bool,
        onCancel: PropTypes.func
    };

    render() {
        const { submitting, handleSubmit, onCancel } = this.props;
        return (
            <form className={'behavior-form'} onSubmit={handleSubmit}>
                <div className={'row'}>
                    <Field
                        component={BasicText}
                        name={'name'}
                        label={'Behavior Name'}
                        className={'row col-12 col-sm-10'}
                        inputClassName={'col-12 col-sm-5 no-padding'}
                        styleProps={{ horizontal: true, inputStyle: { bordered: true, 'full-width': true } }}
                    />
                </div>
                <div className={'row'}>
                    <Field
                        component={BasicTextArea}
                        name={'description'}
                        label={'Behavior Description'}
                        className={'row col-12 col-sm-10'}
                        inputClassName={'col-12 col-sm-5 no-padding'}
                        styleProps={{ horizontal: true, inputStyle: { bordered: true, 'full-width': true } }}
                    />
                </div>
                <div className={'col-12 col-sm-10 formButtons'}>
                    <VerbButton fontAwesomeIcon={'fa-save'} onClick={handleSubmit} disabled={submitting}>
                        SAVE
                    </VerbButton>

                    <VerbButton
                        buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                        fontAwesomeIcon={'fa-ban'}
                        onClick={onCancel}
                        disabled={submitting}
                    >
                        CANCEL
                    </VerbButton>
                </div>
                <FormFeedback {...this.props} className={'col-12'} />
            </form>
        );
    }
}

export const BehaviorFormComponent = BehaviorForm;

const BehaviorFormValidation = {
    form: 'Behavior',
    enableReinitialize: true,
    validate: (values) => {
        const errors = {};
        const error = 'Required field not filled!';

        if (!values.name) {
            errors.name = 'Name is required!';
            errors._error = error;
        }

        if (!values.description) {
            errors.description = 'Description is required!';
            errors._error = error;
        }

        return errors;
    }
};

const mapStateToProps = (state, ownProps) => {
    const { name, description } = ownProps.currentBehavior;
    return {
        initialValues: {
            name,
            description
        }
    };
};

export default compose(connect(mapStateToProps), reduxForm(BehaviorFormValidation))(BehaviorForm);
